module.exports = __webpack_public_path__ + "static/media/CoverPic.9454ca43.jpg";